import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Inject,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { WorkspaceLoadingService } from '../../../shared/misc-services/workspace-loading.service';
import { finalizeSampleIcon } from '../../shared/icons/finalize-sample-icon';
import { TaskReviewFinalizeResourceService } from '../services/task-review-finalize-resource.service';

@Component({
  selector: 'h3-finalize-sample-dialog',
  templateUrl: './finalize-sample-dialog.component.html',
  styleUrl: './finalize-sample-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class FinalizeSampleDialogComponent {
  private readonly workspaceLoadingService = inject(WorkspaceLoadingService);

  finalizeSampleIcon = finalizeSampleIcon;
  isLastUnreviewed: boolean;
  protected isLoading$ = this.workspaceLoadingService.isLoading$;

  private taskReviewFinalizeResource = inject(
    TaskReviewFinalizeResourceService,
  );
  private dialogRef = inject(MatDialogRef);

  constructor(
    @Inject(MAT_DIALOG_DATA)
    data: {
      isLastUnreviewed: boolean;
    },
  ) {
    this.isLastUnreviewed = data.isLastUnreviewed;
  }

  async finalizeSample() {
    this.dialogRef.disableClose = true;
    this.workspaceLoadingService.isLoading$.next(true);
    try {
      await this.taskReviewFinalizeResource.finalizeSample();
      this.dialogRef.close();
    } catch (e) {
      this.dialogRef.disableClose = false;
    } finally {
      this.workspaceLoadingService.isLoading$.next(false);
    }
  }
}
